import React from 'react';
import { useTranslation } from 'react-i18next';

const stats = [
  { value: '7000+', labelKey: 'aboutPageSection.partner.stats.0' },
  { value: '100+', labelKey: 'aboutPageSection.partner.stats.1' },
  { value: '250+', labelKey: 'aboutPageSection.partner.stats.2' },
  { value: '30', labelKey: 'aboutPageSection.partner.stats.3' }
];

const AboutPartnerSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <h2 className="text-3xl font-bold text-[#0F172A] tracking-tight">
            {t('aboutPageSection.partner.title')}
          </h2>
          <p className="text-[#64748B] mt-6 leading-relaxed">
            {t('aboutPageSection.partner.paragraph1')}
          </p>
          <p className="text-[#94A3B8] mt-4 leading-relaxed text-sm">
            {t('aboutPageSection.partner.paragraph2')}
          </p>
          <p className="text-[#94A3B8] mt-4 leading-relaxed text-sm">
            {t('aboutPageSection.partner.paragraph3')}
          </p>
        </div>

        <div className="bg-[#F7F8FA] rounded-2xl p-8 border border-[#E2E8F0]">
          <div className="grid grid-cols-2 gap-4">
            {stats.map((item) => (
              <div key={item.labelKey} className="bg-white rounded-xl p-5 text-center border border-[#E2E8F0]">
                <p className="text-2xl font-bold text-[#0F172A]">{item.value}</p>
                <p className="text-xs text-[#94A3B8] mt-1">{t(item.labelKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default AboutPartnerSection;
